import * as _ from './_helpers.js';
import { $, $$ } from './_queryselector.js';

/**
 * Setup text and textarea inputs within `element`
 **/
export function initInputs(element) {
    element.addEventListener('focus', (e) => {
        const input = e.target.closest('input') || e.target.closest('textarea');
        if (!input) return;

        input.classList.add('-has-focused');
        input.parentNode.classList.add('-is-active');
    }, true);

    // element.addEventListener('input', e => {
    //     const val = e.target.value;

    //     if (val !== '') {
    //         e.target.parentNode.classList.add('-has-text');
    //     } else {
    //         e.target.parentNode.classList.remove('-has-text');
    //     }
    // });

    element.addEventListener('blur', (e) => {
        const input = e.target.closest('input') || e.target.closest('textarea');
        if (!input) return;

        if (input.value === '') {
            input.parentNode.classList.remove('-is-active');
        }
    }, true);
}

/**
 * Set up an event listener for ajax form submissions
 */
export function ajaxForm(form, callback) {
    form.addEventListener('submit', e => {
        e.preventDefault();

        const f = (form.classList.contains('js-form')) ? form : $('.js-form', form);

        $('input[type="submit"]', f).disabled = true;

        const formData = new FormData(f);
        formData.append('data[Contact][page_name]', parallax.pageName);
        const xhr = new XMLHttpRequest();

        xhr.open('POST', f.action);

        xhr.onreadystatechange = () => {
            if (xhr.readyState > 3 && xhr.status === 200) { callback(xhr.responseText); }
        };

        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        xhr.send(formData);
    }, true);
}



// WEBPACK FOOTER //
// ./assets/js/components/_forms.js